module.exports = __webpack_public_path__ + "assets/static/svg/applepay-icon.74e46390b40b9666e6dec6f95ea24402.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./app/assets/images/applepay-icon.svg
 ** module id = 475
 ** module chunks = 1
 **/